"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyTransformPipeline = exports.buildTransformPipeline = void 0;

var _defaults = require("../defaults");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var buildTransformPipeline = function buildTransformPipeline(initial, transform) {
  var transformResponsePipeline;

  if (transform) {
    transformResponsePipeline = Array.isArray(transform) ? transform : [].concat(_toConsumableArray(initial), [transform]);
  } else {
    transformResponsePipeline = _toConsumableArray(initial);
  }

  return transformResponsePipeline;
};

exports.buildTransformPipeline = buildTransformPipeline;

var applyTransformPipeline = function applyTransformPipeline(pipeline) {
  return (// eslint-disable-line arrow-body-style
    function (initial) {
      return pipeline.reduce(function (soFar, fn) {
        return soFar.then(fn);
      }, _defaults.defaultGlobals.Promise.resolve(initial));
    }
  );
};

exports.applyTransformPipeline = applyTransformPipeline;